import { SvgIconProps } from './icon-props';

export default function Beds({ height = 30, width = 30 }: SvgIconProps) {
	return (
		<svg width={width} height={height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.3125 2.8125C3.03636 2.8125 2.8125 3.03636 2.8125 3.3125V26.6875C2.8125 26.9636 3.03636 27.1875 3.3125 27.1875H26.6875C26.9636 27.1875 27.1875 26.9636 27.1875 26.6875V3.3125C27.1875 3.03636 26.9636 2.8125 26.6875 2.8125H3.3125ZM25.9687 25.9687H4.03125V11.7703H25.9687V25.9687ZM6.70031 7.4925V10.5272H13.1109V7.4925C13.1109 7.37807 13.0182 7.28531 12.9037 7.28531H6.9075C6.79307 7.28531 6.70031 7.37807 6.70031 7.4925ZM16.8891 10.5272V7.4925C16.8891 7.37807 16.9818 7.28531 17.0962 7.28531H23.0803C23.1947 7.28531 23.2875 7.37807 23.2875 7.4925V10.5272H16.8891ZM24.5184 10.5272H25.9687V4.03125H4.03125V10.5516H5.48156V7.4925C5.48156 6.70498 6.11998 6.06656 6.9075 6.06656H12.9038C13.6913 6.06656 14.3297 6.70498 14.3297 7.4925V10.5516H15.6825V7.4925C15.6825 6.70498 16.3209 6.06656 17.1084 6.06656H23.0925C23.88 6.06656 24.5184 6.70498 24.5184 7.4925V10.5272Z"
				fill="#1F1F1F"
			/>
		</svg>
	);
}
